<div class="d-flex flex-column bg-login m-0">
  <div class="w-25 mx-auto">
    <div class="card px-2">
      <div class="card-header text-center">
        <div class="mx-auto logo-login mb-4"></div>
        <h5 class="mb-1">{{ "DCO.Password_Recovery_Title" | translate }}</h5>
        <p class="text-muted">{{ "DCO.Password_Recovery_Description" | translate
          }}<!-- Introduce el usuario y acepta. Se enviará por correo un acceso para establecer la contraseña --></p>
      </div>
      <div class="card-body">
        <form class="mb-5" *ngIf="!isLoggedIn">
          <div class="form-group mb-4">
            <label class="form-label fw-semibold mb-2" for="username">{{ "DCO.Password_Recovery_Username" | translate }}<!-- Introduce usuario --></label>
            <input type="username" class="form-control" [(ngModel)]="userLocal" name="user" />
          </div>
          <div class="form-group mb-3">
            <button type="submit" [disabled]="blockButton" class="btn btn-dark rounded-2 w-100 m-0" (click)="sendUSerPwRec()">
              {{ "DCO.Password_Recovery_Accept" | translate }}
            </button>
            <div *ngIf="blockButton" class="d-flex justify-content-center" style=" left: 50%">
              <div class="spinner-border spinner-border-smtext-primary"></div>
            </div>
          </div>
          <div class="alert alert-success" *ngIf="resetPasswordSent">
            {{ "DCO.Password_Recovery_Success" | translate }}
          </div>
          <div class="form-group">
            <button *ngIf="resetPasswordSent" type="submit" class="btn btn-outline-dark rounded-2 w-100 m-0" (click)="NavigateLogin()">
              {{ "DCO.Login_LoginButton" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>